import React, {useEffect, useState} from 'react';
import styles from './styles';
import {Form, Loader, SuccessSvg, ErrorSvg, InOutAnimation as Animation, removeStagingMedia} from '@xpertdox_js/xdcomponents';
import ContactTable from './ContactTable';
import axios from 'axios';
import axiosConfig from '../../../config/axios.config';
import {UserContext} from '../../../Context/UserContext';
// import csvFile from '../../../assets/email-contacts-upload-example.csv';
import UploadsSection from './UploadsSection';
import formSettings from './formSettings';
import csvUploadHandler from './csvUploadHandler';
import unStageAssets from './unStageAssets';
import { trackError } from '../../../utils/activityTracker'

const EmailBroadcast = props => {
  const [formState, setFormState] = useState({});
  const [contactList, setContactList] = useState([]);
  const [showContacts, setShowContacts] = useState(false);
  const [removedContacts, setRemovedContacts] = useState([]);
  const [selectedTrials, setSelectedTrials] = useState([]);
  const [status, setStatus] = useState(null);
  const { user, userAction } = React.useContext(UserContext);
  const addAsset = asset => {
    let update = props.assets.slice();
    update.push(asset);
    props.setAssets(update);
  }
  const removeAsset = asset => props.setAssets(props.assets.filter(
    a => a.filename !== asset.filename
  ));
  const addRemovedContact = email => {
    let update = removedContacts.slice();
    update.push(email);
    setRemovedContacts(update);
  }
  useEffect(() => () => {
    if (props.assets.length) removeStagingMedia(props.assets.map(asset => asset._id), axiosConfig);
    props.setAssets([]);
  }, [])

  const uploadContacts = list => {
    let prev = contactList.slice();
    let prevEmails = prev.map(item => item.email) || [];
    let newContacts = [];
    list.forEach(item => {
      if (!prevEmails.includes(item.email)) newContacts.push(item);
      else prev = prev.filter(fItem => fItem.email !== item.email);
    })
    let result = newContacts.concat(prev);
    if (!showContacts) setShowContacts(true);
    setContactList(result);
  }

  const handleFormUpload = e => csvUploadHandler(e, uploadContacts);

  const close = (e, force) => {
    if (typeof e === 'undefined'
    || (e.target && e.target.id === 'tui_email_broadcast'))
    props.setBroadcasting(false);
  }

  let contacts1 = props.data ? props.data
  .filter(obj => !removedContacts.includes(obj.email))
  .map((obj, i) => {
    return {
      name: obj.firstName,
      email: obj.email,
      id: obj.firstName + i
    }
  })
  : [];

  let contacts2 = []
  if (contactList.length) {
    contacts2 = contactList.slice()
    .filter(obj => !removedContacts.includes(obj.email))
    .map((obj, i) => {
      return {
        name: obj.name,
        email: obj.email,
        id: obj.name + i
      }
    })
  }
  const allContacts = contacts1.concat(contacts2)
  let contacts = [];
  let records = []
  allContacts.forEach(contact => {
    let record = contact.email + contact.name;
    if (!records.includes(record)) {
      contacts.push(contact);
      records.push(record)
    }
  })

  const count = contacts.length;
  const handleCountEdit = () => setShowContacts(!showContacts);


  const handleSubmit = async (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
    const stagedAssets = props.assets.length > 0
      ? await unStageAssets(props.assets)
      : true;
    console.log(stagedAssets, ' <- assets ready for email.');
    console.log('past unstaging')
    const values = {...formState};
    let data = {
      user: user.id,
      instance: props.instance,
      senderEmail: values.bc_email,
      email: {
        subject: values.bc_subject,
        message: values.bc_message,
        attachments: stagedAssets,
        trials: selectedTrials,
      },
      contacts: contacts,
    }
    if (showContacts) setShowContacts(false);
    setStatus('loading')
    const timedClose = () => setTimeout(() => close(), 1000)
    console.log('Form --------------')
    axios.post(`${axiosConfig.apiUrl}/rt/console/mail_patients`, data) // removed 'axiosConfig.auth' as token is updated on login
    .then(res => {
      console.log(res);
      if (res.error) setStatus(false);
      setStatus(true);
      timedClose();
    })
    .catch(err => {
      console.error(err)
      trackError({ error: err, history: props.history })
        if (err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
      setStatus(false);
      timedClose();
    });

    console.log(data);
  }

  const svgProps = {
    width:'85px',
    fontSize:'28px',
    padding:'0 0 25px 0',
  }

  return(
    <React.Fragment>
    <div style={styles.container} id='tui_email_broadcast'>
      <div style={styles.innerContainer}>
        <div style={{...styles.clearfix, ...styles.contentContainer}}>
          {status === null &&
            <React.Fragment>
              <div style={{...styles.clearfix, position: 'relative'}}>
                <h4 style={styles.title}>Broadcast Email</h4>
                <UploadsSection
                  count={count}
                  uploadContacts={uploadContacts}
                  assets={props.assets}
                  removeAsset={removeAsset}
                  addAsset={addAsset}
                  setShowContacts={setShowContacts}
                  showContacts={showContacts}
                  selectedTrials={selectedTrials}
                  setSelectedTrials={setSelectedTrials}
                />
              </div>
              <div style={styles.formContainer}>
                <Form
                  settings={formSettings}
                  handleSubmit={handleSubmit}
                  state={{formState: formState, setFormState: setFormState}}
                />
              </div>
            </React.Fragment>
          }
          {status === 'loading' && <div style={{position: 'relative', width: '100%', height: '300px'}}>
            <Loader noBg height={'320px'} />
          </div>
          }
          {status === true &&
            <SuccessSvg
              text='Email(s) Sent Successfully'
              {...svgProps}
            />
          }
          {status === false &&
            <ErrorSvg
              text='Error Sending Email(s)'
              {...svgProps}
            />
          }
        </div>
      </div>
    </div>
    <Animation
      animation={{
        in: [
          ['transform', {0: 0, 100: 100}, 320, {easing: 'easeOut', valueMap: 'translateX($v%)'}]
        ],
        out: showContacts ? null : [
          ['transform', {0: 100, 100: 0}, 320, {easing: 'easeIn', valueMap: 'translateX($v%)'}]
        ]
      }}
      condition={showContacts}
      wrapStyles={styles.contactTableWrap}
    >
      <ContactTable
        addRemovedContact={addRemovedContact}
        contacts={contacts}
        showContacts={setShowContacts}
        count={count}
      />
    </Animation>
    </React.Fragment>
  )
}


export default EmailBroadcast;
